const type = 'SET_CALL_HISTORY_LOADING';

const setCallHistoryLoading = (data) => ({
  data,
  type,
});

export { type };
export default setCallHistoryLoading;
